import { render, staticRenderFns } from "./ZendeskWidgetButton.vue?vue&type=template&id=4f94e2e1&scoped=true&"
import script from "./ZendeskWidgetButton.vue?vue&type=script&lang=js&"
export * from "./ZendeskWidgetButton.vue?vue&type=script&lang=js&"
import style0 from "./ZendeskWidgetButton.vue?vue&type=style&index=0&id=4f94e2e1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f94e2e1",
  null
  
)

export default component.exports